import { HostListener } from '@angular/core';
import { NavController, PopoverController, AlertController, ActionSheetController } from 'ionic-angular';
import { Subscription } from 'rxjs/Subscription';
import { Http } from '@angular/http';
import { Deferred } from 'prophecy/src/Deferred';
import { EditTextPage } from '../pages/edit-text/edit-text';
import { MessageService } from './message.service';
import { DatastoreService } from './datastore.service';
import { Credentials } from './credentials';
import { CredentialsService } from './credentials.service';
import { HubService } from './hub.service'

var utils = ($ as any).pivotUtilities;
// var heatmap =  utils.renderers["Heatmap"];
// var sumOverSum =  utils.aggregators["Sum over Sum"];
declare var google;
declare var pako;

export class WidgetBase {
    widgetTitle: string;
    configureStateText = 'Configure';
    wantReloadOnEntry = false;
    wantDataRefresh = false;
    widgetConfig;
    active = false;
    credentials: Credentials;
    widgetData;
    loading;
    copyView;
    configHidSideMenu;
    pivotListSelected;
    pivotListForUser;
    viewListSelected;
    viewListForUser;
    subscription: Subscription;
    loadingMessage = 'Loading';
    pivotElId;
    quickFilters = [];
    isFiltered;
    oldRenderer;

    constructor(
        public alertCtrl: AlertController,
        public actionSheetCtrl: ActionSheetController,
        public navCtrl: NavController,
        public http: Http,
        public popoverCtrl: PopoverController,
        public messageService: MessageService,
        public datastoreService: DatastoreService,
        public credentialsService: CredentialsService,
        public hubService: HubService,
        public pageIndex,
        public autoRefresh,
      ) {
      this.credentials = this.credentialsService.getCredentials();
      this.loading = false;
      this.copyView = false;
      this.isFiltered = false;
      this.configHidSideMenu = false;
      if (this.autoRefresh) {
       this.autoRefresh = JSON.parse(this.autoRefresh);
      }
      this.widgetTitle = 'Page ' + pageIndex.toString();
      this.pivotElId = 'pivot-widget-' + this.pageIndex.toString();
      this.subscription = this.messageService.getMessage().subscribe(message => {
        if (message.text === '[[ReloadWidgets]]') {
          this.wantReloadOnEntry = true;
          this.widgetConfig = null;
        }
        if (message.text === '[[RefreshDataAndReloadWidgets]]') {
          this.wantDataRefresh = true;
          this.wantReloadOnEntry = true;
          this.widgetConfig = null;
        }
        if (message.text.indexOf('[HubService]') >= 0) {
          this.loadingMessage = message.text.split('[HubService]')[1];
        }
        if (message.text.indexOf('[[widget' + this.pageIndex.toString() + 'Title]]') >= 0) {
          let name = message.text.split('[[widget' + this.pageIndex.toString() + 'Title]]')[1];
          window.localStorage.setItem('widget' + this.pageIndex.toString() + 'Title', name);
          // TODO: Disable drag
          if (this.configureStateText !== 'Configure') {
            this.toggleConfigUi(undefined);
          }
          this.widgetTitle = name;
          this.loadPage();
        }
        if (message.text.indexOf('[[widget' + this.pageIndex.toString() + 'LoadClean]]') >= 0) {
          this.loadPage();
        }
      });
    }

    @HostListener('window:beforeunload', ['$event'])
    checkForUnsavedDataWarnUser($event) {
      if (this.viewListSelected !== null &&
        this.viewListSelected !== undefined &&
        (this.pivotListSelected === null ||
        this.pivotListSelected === undefined)) {
          $event.returnValue='You haven\'t saved your changes to a View - your edits will be lost!';
      }
    }

    loadPage() {
      if (this.loading) {
        return;
      }
      var pageName = window.localStorage.getItem('widget' + this.pageIndex.toString() + 'Title');
      if (pageName !== null) {
        this.widgetTitle = pageName;
      }
      this.loading = true;
      // Get list of pivot views
      this.datastoreService.get('pivotListForUser').then((data) => {
        this.pivotListForUser = JSON.parse(data);
        this.datastoreService.get('viewListForUser').then((data) => {
          this.viewListForUser = JSON.parse(data);
          let widgetDataPromise = this.datastoreService.get(
            'widget' + this.pageIndex.toString() + 'SelectedPivotId');
          widgetDataPromise.then(
            (widgetSelectedPivotId) => {
              console.log('widget' + this.pageIndex.toString() + 'SelectedPivotId=', widgetSelectedPivotId);
              if (widgetSelectedPivotId === null || widgetSelectedPivotId === 'null'|| widgetSelectedPivotId === '0') {
                console.log('No widgetSelectedPivotId');
                // None are selected.
                // Uncomment the following to, by default, open Config mode.
                // if (this.configureStateText === 'Configure') {
                //   this.toggleConfigUi(undefined);
                // }
                this.widgetConfig = null;
                this.pivotListSelected = null;
                this.viewListSelected = null;
                this.widgetData = [];
                this.loadPivot();
              }
              else {
                console.log('widgetSelectedPivotId=', widgetSelectedPivotId);
                this.pivotListSelected = Number(widgetSelectedPivotId);
                this.newPivotSelected(Number(widgetSelectedPivotId));
              }
            }
          );
        });
        this.loading = false;
      });
    }

    ionViewDidEnter() {
      if (this.wantReloadOnEntry) {
        this.loadPage();
        this.wantReloadOnEntry = false;
      }
      setTimeout(()=> {
        window.dispatchEvent(new Event('resize'));
      }, 10);
    }

    ionViewDidLoad() {
      this.loadPage();
    }

    prepareCopyToClipboard(event) {
      let pivot = document.getElementById('pivot-widget-' + this.pageIndex.toString());
      let pvtRenderers = pivot.getElementsByClassName('pvtRenderer') as HTMLCollectionOf<HTMLSelectElement>;
      this.oldRenderer = pvtRenderers[0].value;
      pvtRenderers[0].value = 'TSV Export';
      // Create a new 'change' event
      var changeEvent = new Event('change');
      pvtRenderers[0].dispatchEvent(changeEvent);
      this.copyView = true;
    }

    copyToClipboard(event) {
      let pivot = document.getElementById('pivot-widget-' + this.pageIndex.toString());
      let pvtRendererAreas = pivot.getElementsByClassName('pvtRendererArea') as HTMLCollectionOf<HTMLElement>;
      let textareas = pvtRendererAreas[0].getElementsByTagName('textarea') as HTMLCollectionOf<HTMLTextAreaElement>;
      textareas[0].select();
      document.execCommand('copy');
      setTimeout(() => {
        let pvtRenderers = pivot.getElementsByClassName('pvtRenderer') as HTMLCollectionOf<HTMLSelectElement>;
        pvtRenderers[0].value = this.oldRenderer;
        var changeEvent = new Event('change');
        pvtRenderers[0].dispatchEvent(changeEvent);
        this.copyView = false;
      }, 500);
    }

    quickFilter(event) {
      let buttons = [];
      for (let attr of this.quickFilters) {
        buttons.push({
          text: attr.name.toUpperCase(),
          icon: 'md-funnel',
          role: 'destructive',
          handler: () => {
            this.messageService.sendMessage('[[widgetUpdated]]' + this.pageIndex.toString() + ',' +
              '680');
            attr.clickableEl.click();
          },
          cssClass: (attr.isFiltered ? 'filterItalic' : 'filterNormal')
        });
      }
      buttons.push({
        text: 'CANCEL',
        role: 'cancel',
        icon: 'md-close-circle',
        handler: () => {
          console.log('Cancel clicked');
        }
      });
      let actionSheet = this.actionSheetCtrl.create({
        title: 'CHOOSE ATTRIBUTE TO FILTER',
        buttons: buttons
      });
      actionSheet.present();
    }

    refreshData(event) {
      this.loading = true;
      let newPivot = this.pivotListForUser.find((x) => x.pivot_view_id == this.pivotListSelected);
      this.loadingMessage = 'Downloading data from server';
      this.hubService.getViewData(newPivot.view_id).then((result) => {
        if (result !== 'OK') {
          this.loading = false;
          return;
        }
        this.getAndDisplayViewData(newPivot.view_id);
      });
    }

    refreshPivotViewListsForUser(pivotName=undefined) {
      this.hubService.getPivotListForUser().then((result) => {
        if (result !== 'OK') {
          this.loading = false;
          return;
        }
        // console.log('getPivotListForUser OK');
        this.hubService.getViewListForUser().then((result) => {
          if (result !== 'OK') {
            this.loading = false;
            return;
          }
          // console.log('getViewListForUser OK');
          this.loading = true;
          // Get list of pivot views
          this.datastoreService.get('pivotListForUser').then((data) => {
            this.pivotListForUser = JSON.parse(data);
            this.datastoreService.get('viewListForUser').then((data) => {
              this.viewListForUser = JSON.parse(data);
              let deferredPromise = new Deferred();
              if (pivotName !== undefined) {
                let newPivot = this.pivotListForUser.find((x) => x.pivot_view_name == pivotName);
                this.datastoreService.set('widget' + this.pageIndex.toString() + 'SelectedPivotId',
                  newPivot.pivot_view_id.toString()).then(() => {
                    deferredPromise.resolve('OK');
                  });
              }
              else {
                deferredPromise.resolve('OK');
              }
              deferredPromise.promise.then(() => {
                let widgetDataPromise = this.datastoreService.get(
                  'widget' + this.pageIndex.toString() + 'SelectedPivotId');
                widgetDataPromise.then(
                  (widgetSelectedPivotId) => {
                    if (widgetSelectedPivotId === null) {
                      // console.log('No widgetSelectedPivotId');
                      // None are selected.
                      if (this.configureStateText === 'Configure') {
                        this.toggleConfigUi(undefined);
                      }
                    }
                    else {
                      // console.log('widgetSelectedPivotId=', widgetSelectedPivotId);
                      this.pivotListSelected = Number(widgetSelectedPivotId);
                      this.newPivotSelected(Number(widgetSelectedPivotId));
                    }
                  }
                );
              });
            });
            this.loading = false;
          });
        });
      });
    }

    loadPivot() {
      let widgetConfigPromise = this.datastoreService.get('widget' + this.pageIndex.toString() + 'PivotConfig');
      widgetConfigPromise.then(
        (widgetPivotConfig) => {
          // console.log('widgetPivotConfig=', widgetPivotConfig);
          if (widgetPivotConfig === null) {
            // console.log('No widgetPivotConfig');
            // Get from current pivot view
            if (this.pivotListSelected !== null) {
              let pivot = this.pivotListForUser.find((x) => x.pivot_view_id == this.pivotListSelected);
              if (pivot.pivot_view_config !== undefined &&
                pivot.pivot_view_config !== null &&
                pivot.pivot_view_config !== '') {
                  this.renderData(JSON.parse(pivot.pivot_view_config));
                  return;
                }
            }
            this.renderData();
          }
          else {
            // console.log('widgetPivotConfig=', widgetPivotConfig);
            this.renderData(JSON.parse(widgetPivotConfig));
          }
        }
      );
    }

    getAndDisplayViewData(view_id, recursing=false) {
      this.datastoreService.keys().then((keys) => {
        let chunks = [];
        for (var idx in keys) {
          if (keys[idx].indexOf('viewData:' + view_id.toString() + ':') >= 0) {
            chunks.push({
              id: Number(keys[idx].split('viewData:' + view_id.toString() + ':')[1]),
              key: keys[idx]
            });
          }
        }
        if (chunks.length === 0 || (!recursing && (this.wantDataRefresh || this.autoRefresh))) {
          this.wantDataRefresh = false;
          // Not in storage. Try to load from server.
          // console.log('Downloading data from server');
          this.loadingMessage = 'Downloading data from server';
          this.hubService.getViewData(view_id).then((result) => {
            // Note result will be undefined if another widget was already
            // loading the same view.
            if (result !== 'OK' && result !== undefined) {
              this.loading = false;
              this.loadingMessage = 'Loading';
              return;
            }
            this.getAndDisplayViewData(view_id, true);
          });
          return;
        }
        chunks.sort((a, b) => a.id < b.id ? -1 : a.id > b.id ? 1 : 0);
        // console.log('chunks=', chunks);
        let deferredPromiseChain = [];
        for (let chunkIndex = 0; chunkIndex < chunks.length; ++chunkIndex) {
          let deferredPromiseForChunk = new Deferred();
          deferredPromiseChain.push(deferredPromiseForChunk);
          this.datastoreService.get(chunks[chunkIndex].key).then((dataChunk) => {
            chunks[chunkIndex].data = dataChunk;
            deferredPromiseForChunk.resolve('Retreived View Data Chunk' + chunkIndex.toString());
          });
        }
        let deferredPromiseChainToDo = deferredPromiseChain.length;
        if (deferredPromiseChain.length > 0) {
          this.loadingMessage  = 'Loading data (' +
            (1).toString() + ' of ' +
            deferredPromiseChain.length.toString() + ' chunks)';
          let chunksToLoad = deferredPromiseChain.length;
          for (var defIdx = 0; defIdx < deferredPromiseChain.length; ++defIdx) {
            deferredPromiseChain[defIdx].promise.then((result)=> {
              // console.log('promise result:', result);
              deferredPromiseChainToDo -= 1;
              this.loadingMessage  = 'Loading data (' +
                (chunksToLoad - deferredPromiseChainToDo + 1).toString() + ' of ' +
                chunksToLoad.toString() + ' chunks)';
              // console.log('deferredPromiseChainToDo=', deferredPromiseChainToDo);
              if (deferredPromiseChainToDo === 0) {
                // All done
                this.loadingMessage = 'Loading visualisation';
                // console.log('All done!');
                this.widgetData = [];
                for (let chunkIndex = 0; chunkIndex < chunks.length; ++chunkIndex) {
                  // console.log(this.big_json_parse(chunks[chunkIndex].data));
                  this.widgetData = this.widgetData.concat(this.big_json_parse(chunks[chunkIndex].data));
                  // deferredPromise.resolve('All chunks stored');
                }
                // console.log(this.widgetData);
                this.loadPivot();
              }
            });
          }
        }
      });
    }

    newPivotSelected(event) {
      // console.log('newPivotSelected=', this.pivotListForUser);
      // console.log('newPivotSelected=', this.pivotListForUser[event]);
      this.viewListSelected = null;
      let newPivot = this.pivotListForUser.find((x) => x.pivot_view_id == event);
      // console.log('newPivot=', newPivot);
      this.loading = true;
      if (newPivot === undefined) {
        if (this.configureStateText === 'Configure') {
          this.toggleConfigUi(undefined);
        }
        this.loading = false;
        return;
      }
      // TODO: set returns a promise - may want to block.
      this.datastoreService.set('widget' + this.pageIndex.toString() + 'SelectedPivotId',
        newPivot.pivot_view_id.toString()).then(() => {
          this.datastoreService.set('widget' + this.pageIndex.toString() + 'PivotConfig', null).then(() => {
            this.getAndDisplayViewData(newPivot.view_id);
          });
      });
    }

    newViewSelected(event) {
      this.pivotListSelected = null;
      this.loading = true;
      let newView = this.viewListForUser.find((x) => x.view_id == event);
      // console.log('newViewSelected event=', event);
      this.getAndDisplayViewData(newView.view_id);
    }

    big_json_parse(data) {
      return JSON.parse(data)[0][0];
    }

    editWidgetTitle(event) {
      let popover = this.popoverCtrl.create(EditTextPage, {label: 'Page name', value: this.widgetTitle});
      popover.present({
        ev: event
      });
      popover.onDidDismiss((popoverData) => {
        if (popoverData) {
          this.widgetTitle = popoverData;
          this.messageService.sendMessage('[[widget' + this.pageIndex.toString() + 'Title]]' + popoverData);
        }
      })
    }

    // TODO: add promises and spinner
    saveNewPivot(event) {
      let popover = this.popoverCtrl.create(EditTextPage, {label: 'New View Name', value: ''});
      popover.present({
        ev: event
      });
      popover.onDidDismiss((popoverData) => {
        if (popoverData) {
          this.loading = true;
          // console.log('popoverData=', popoverData);
          // Must at least have a view selected
          let newView = this.viewListForUser.find((x) => x.view_id == this.viewListSelected);
          if (newView === undefined) {
            let newPivot = this.pivotListForUser.find((x) => x.pivot_view_id == this.pivotListSelected);
            this.hubService.savePivotToServer(-1, newPivot.view_id, popoverData, 'New pivot', this.widgetConfig).then(
              (result) => {
                if (result !== 'OK') {
                  this.loading = false;
                  return;
                }
                this.refreshPivotViewListsForUser(popoverData);
              });
            return;
          }
          this.hubService.savePivotToServer(-1, newView.view_id, popoverData, 'New pivot', this.widgetConfig).then(
            (result) => {
              if (result !== 'OK') {
                this.loading = false;
                return;
              }
              this.refreshPivotViewListsForUser(popoverData);
            });
        }
      })
    }

    savePivot(event) {
      let newPivot = this.pivotListForUser.find((x) => x.pivot_view_id == this.pivotListSelected);
      this.hubService.savePivotToServer(newPivot.pivot_view_id, newPivot.view_id, '', '', this.widgetConfig);
    }

    deletePivot(event) {
      this.loading = true;
      let alert = this.alertCtrl.create({
        title: 'Confirm delete view',
        message: 'Do you want to permanently delete this view?',
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            handler: () => {
              console.log('Cancel clicked');
              this.loading = false;
            }
          },
          {
            text: 'DELETE',
            handler: () => {
              let newPivot = this.pivotListForUser.find((x) => x.pivot_view_id == this.pivotListSelected);
              this.hubService.deletePivotOnServer(newPivot.pivot_view_id).then((result) => {
                if (result !== 'OK') {
                  this.loading = false;
                  return;
                }
                this.refreshPivotViewListsForUser();
              })
            }
          }
        ]
      });
      alert.present();
    }

    toggleConfigUi(event) {
      // TODO: Disable drag
      if (this.configureStateText === 'Configure') {
        this.configureStateText = 'Hide Configuration';
        let twoColumnRow = document.getElementById('two-column-row');
        twoColumnRow.style.display = 'inline-block';
        this.renderData(JSON.parse(this.widgetConfig));
        setTimeout(() => {
          this.messageService.sendMessage('[[widgetUpdated]]' + this.pageIndex.toString() + ',' +
            (screen.height - 50).toString());
          let pivot = document.getElementById('pivot-widget-' + this.pageIndex.toString());
          let pvtUis = pivot.getElementsByClassName('pvtUi') as HTMLCollectionOf<HTMLElement>;
          if (pvtUis !== undefined && pvtUis[0] !== undefined && pvtUis[0].style != undefined) {
            pvtUis[0].style.height = (screen.height - 190).toString() + 'px';
            let splitPaneVisibles = document.getElementsByClassName('split-pane-visible') as HTMLCollectionOf<HTMLElement>;
            this.configHidSideMenu = false;
            if (splitPaneVisibles !== undefined && splitPaneVisibles !== null) {
              this.configHidSideMenu = true;
            }
            this.messageService.sendMessage('[[hideSideMenu]]');
          }
        }, 10);
      }
      else {
        this.configureStateText = 'Configure';
        let twoColumnRow = document.getElementById('two-column-row');
        twoColumnRow.style.display = 'flex';
        this.renderData(JSON.parse(this.widgetConfig));
        let pivot = document.getElementById('pivot-widget-' + this.pageIndex.toString());
        if (pivot !== undefined && pivot !== null) {
          let pvtRendererAreas = pivot.getElementsByClassName('pvtRendererArea') as HTMLCollectionOf<HTMLElement>;
          if (pvtRendererAreas !== undefined && pvtRendererAreas !== null && pvtRendererAreas.length > 0) {
            this.messageService.sendMessage('[[widgetUpdated]]' + this.pageIndex.toString() + ',' +
              pvtRendererAreas[0].offsetHeight.toString());
            let pvtUis = pivot.getElementsByClassName('pvtUi') as HTMLCollectionOf<HTMLElement>;
            if (pvtUis !== undefined && pvtUis !== null && pvtUis.length > 0) {
              pvtUis[0].style.height = (pvtRendererAreas[0].offsetHeight + 30).toString() + 'px';
            }
          }
        }
        if (this.configHidSideMenu) {
          this.messageService.sendMessage('[[showSideMenu]]');
        }
      }
      this.updatePivotView();
    }

    updatePivotView() {
      let pivot = document.getElementById('pivot-widget-' + this.pageIndex.toString());
      let pvtRendererSelectLabels = pivot.getElementsByClassName('pvtRendererSelectLabel') as HTMLCollectionOf<HTMLElement>;
      pvtRendererSelectLabels[0].style['display'] = (this.configureStateText !== 'Configure' ? '': 'none');
      let pvtUnused = pivot.getElementsByClassName('pvtUnused') as HTMLCollectionOf<HTMLElement>;
      if (pvtUnused[0] === undefined) {
        return;
      }
      pvtUnused[0].style['display'] = (this.configureStateText !== 'Configure' ? '': 'none');
      let pvtVals = pivot.getElementsByClassName('pvtVals') as HTMLCollectionOf<HTMLElement>;
      pvtVals[0].style['display'] = (this.configureStateText !== 'Configure' ? '': 'none');
      let pvtRenderers = pivot.getElementsByClassName('pvtRenderer') as HTMLCollectionOf<HTMLElement>;
      pvtRenderers[0].style['display'] = (this.configureStateText !== 'Configure' ? '': 'none');
      let pvtAxisContainers = pivot.getElementsByClassName('pvtAxisContainer') as HTMLCollectionOf<HTMLElement>;
      for (var i = 0; i < pvtAxisContainers.length; ++i) {
        pvtAxisContainers[i].style['display'] = (this.configureStateText !== 'Configure' ? '': 'none');
      }
      setTimeout(()=> {
        window.dispatchEvent(new Event('resize'));
      }, 10);
    }

    uncompress(base64data) {
      var compressData = atob(base64data);
      var compressDataArray = compressData.split('').map(function(e) {
          return e.charCodeAt(0);
      });
      var binData = new Uint8Array(compressDataArray);
      var data = pako.inflate(binData);
      var uArray = new Uint16Array(data);
      var resultString = ''
      for (var idx = 0; idx < uArray.length; ++idx) {
        resultString += String.fromCharCode(uArray[idx]);
      }
      return resultString;
    }

    renderData(widgetConfig=undefined) {
      // console.log('Rendering');
      google.charts.load("current", "1", {
        packages:["corechart", "charteditor"],
        callback: this.renderDataAfterGoogleLoad(widgetConfig)});
    }

    renderDataAfterGoogleLoad(widgetConfig=undefined) {
      if (google.visualization === undefined ||
      typeof google.visualization.arrayToDataTable !== "function" ||
      document.getElementById('pivot-widget-' + this.pageIndex.toString()) === null) {
        // Not sure why this is needed given the setOnLoadCallback - that callback
        // is called even if google.visualization === undefined.
        setTimeout(() => {
          this.renderDataAfterGoogleLoad(widgetConfig);
        }, 100);
        return;
      }
      this.loading = false;
      if (widgetConfig === undefined) {
        widgetConfig = {
          renderers: ($ as any).extend(
            utils.renderers,
            utils.d3_renderers,
            utils.c3_renderers,
            utils.gchart_renderers,
            utils.export_renderers,
            utils.mapbox_renderers,
            utils.hivis_metrics_renderer
          ),
          onRefresh: (config) => {
            let configCopy = JSON.stringify(config);
            this.widgetConfig = configCopy;
            this.datastoreService.set('widget' + this.pageIndex.toString() + 'PivotConfig', configCopy);
            this.loadingMessage = 'Loading';
            // FIXME: The widget needs to be finished rendering before resizing the
            // parent card to fit it (do it twice to make sure it happens as early as possible,
            // or as late as needed).
            // Renderers have async behaviour, so not easy but could in theory
            // add promises instead of setting the display (sending size messages).
            setTimeout(() => {
              this.reconfigPivotDisplay();
            }, 1000);
            setTimeout(() => {
              this.reconfigPivotDisplay();
            }, 5000);
            // console.log('configCopy=', configCopy);
          }
        };
        widgetConfig.autoSortUnusedAttrs = true;
      }
      else {
        widgetConfig.renderers = ($ as any).extend(
          utils.renderers,
          utils.d3_renderers,
          utils.c3_renderers,
          utils.gchart_renderers,
          utils.export_renderers,
          utils.mapbox_renderers,
          utils.hivis_metrics_renderer
        );
        widgetConfig.onRefresh = (config) => {
          let configCopy = JSON.stringify(config);
          this.widgetConfig = configCopy;
          this.datastoreService.set('widget' + this.pageIndex.toString() + 'PivotConfig', configCopy);
          this.loadingMessage = 'Loading';
          setTimeout(() => {
            this.reconfigPivotDisplay();
          }, 1000);
          setTimeout(() => {
            this.reconfigPivotDisplay();
          }, 5000);
          // console.log('configCopy=', configCopy);
        };
        widgetConfig.localeStrings = undefined;
        widgetConfig.aggregators = undefined;
        widgetConfig.autoSortUnusedAttrs = true;
        // console.log('widgetPivotConfig=', widgetConfig);
      }
      let widgetContainer = document.getElementById(
        'widget-container-' + 'pivot-widget-' + this.pageIndex.toString());
      // console.log('widgetContainer.offsetWidth=', widgetContainer.offsetWidth);
      if (this.configureStateText !== 'Configure') {
        widgetConfig.rendererOptions = {
          c3: {
            size: { width: widgetContainer.offsetWidth - 200}
          },
          d3: {
            size: { width: widgetContainer.offsetWidth - 200}
          },
          gchart: {width: widgetContainer.offsetWidth - 210},
          mapbox: {width: widgetContainer.offsetWidth - 200, widgetId: this.pageIndex.toString()}
        };
      }
      else {
        widgetConfig.rendererOptions = {
          c3: {
            size: { width: widgetContainer.offsetWidth - 50}
          },
          d3: {
            size: { width: widgetContainer.offsetWidth - 50}
          },
          gchart: {width: widgetContainer.offsetWidth - 60},
          mapbox: {width: widgetContainer.offsetWidth - 50, widgetId: this.pageIndex.toString()}
        };
      }
      ($("#pivot-widget-" + this.pageIndex.toString()) as any).pivotUI(
        this.widgetData, widgetConfig, true
      );
      // Hack to move filters out of the first "unused" column (which can be hidden).
      let pivot = document.getElementById('pivot-widget-' + this.pageIndex.toString());
      let pvtFilterBoxes = pivot.getElementsByClassName('pvtFilterBox') as HTMLCollectionOf<HTMLElement>;
      Array.from(pvtFilterBoxes).forEach(function(pvtFilterBox) {
        if (pvtFilterBox.parentElement.classList.contains('pvtUnused')) {
          pvtFilterBox.parentElement.removeChild(pvtFilterBox);
          pivot.appendChild(pvtFilterBox);
        }
      });
      setTimeout(() => {
        this.updatePivotView();
      }, 1000);
    }

    reconfigPivotDisplay() {
      if (this.configureStateText === 'Hide Configuration') {
        return;
      }
      let pivot = document.getElementById('pivot-widget-' + this.pageIndex.toString());
      let pvtUis = pivot.getElementsByClassName('pvtUi') as HTMLCollectionOf<HTMLElement>;
      let pvtRendererAreas = pivot.getElementsByClassName('pvtRendererArea') as HTMLCollectionOf<HTMLElement>;
      this.messageService.sendMessage('[[widgetUpdated]]' + this.pageIndex.toString() + ',' +
        pvtRendererAreas[0].offsetHeight.toString());
      pvtUis[0].style.height = (pvtRendererAreas[0].offsetHeight + 30).toString() + 'px';
      let pvtAttrs = pivot.getElementsByClassName('pvtAttr') as HTMLCollectionOf<HTMLElement>;
      this.quickFilters = [];
      this.isFiltered = false;
      Array.from(pvtAttrs).forEach((pvtAttr) => {
        // Allow all fields to be used to filter from quickfilter
        // TODO: allow this set of fields to be configurable
        //
        // console.log(pvtAttr.parentElement.parentElement.classList.contains('pvtUnused'));
        // Attribute name
        // console.log(pvtAttr.innerText.split('...')[0]);
        // console.log(pvtAttr.parentElement.classList.contains('pvtFilteredAttribute'));
        let pvtTriangles = pvtAttr.getElementsByClassName('pvtTriangle') as HTMLCollectionOf<HTMLElement>;
        let isFiltered = pvtAttr.parentElement.classList.contains('pvtFilteredAttribute');
        this.isFiltered = isFiltered || this.isFiltered;
        this.quickFilters.push({
          name: pvtAttr.innerText.split('...')[0],
          clickableEl: pvtTriangles[0],
          isFiltered: isFiltered
          });
      });
    }
}



// WEBPACK FOOTER //
// ./src/app/widget-base.ts